/** TASK-00302 — Admin Execution Plan target type UX (Worker vs External API). */

export const EXECUTION_PLAN_CREATE_TARGET_TYPES = [
  { value: 'LOCAL_WORKER', label: 'Worker' },
  { value: 'EXTERNAL_API', label: '外部 API' },
] as const

export const WORKER_DISPATCH_PINNED = 'pinned'
export const WORKER_DISPATCH_AUTO = 'auto'

export function isWorkerExecutionTarget(type: string | null | undefined): boolean {
  return type === 'LOCAL_WORKER' || type === 'BROWSER_PROVIDER'
}

export function isExternalApiExecutionTarget(type: string | null | undefined): boolean {
  return type === 'EXTERNAL_API'
}

export function executionTargetDisplayLabel(type: string | null | undefined): string {
  if (!type) return '—'
  if (type === 'LOCAL_WORKER' || type === 'BROWSER_PROVIDER') return 'Worker'
  if (type === 'EXTERNAL_API') return '外部 API'
  if (type === 'FUTURE') return '预留'
  return type
}

export function workerAdvertisesCapability(
  advertised: string[] | null | undefined,
  required: string | null | undefined,
): boolean {
  if (!required) return true
  if (!advertised?.length) return false
  return advertised.includes(required)
}

export type ExecutionPlanWorkerRuntimeRow = {
  worker_id: string
  display_name: string
  status: string
  online: boolean
  display_status?: string
  device_id?: string | null
  worker_software_id?: string | null
  worker_release_id?: string | null
  runtime_id?: string | null
  capability_count: number
  advertised_capabilities: string[]
  version?: string | null
}

export function formatWorkerRuntimeOptionLabel(row: ExecutionPlanWorkerRuntimeRow): string {
  const status = row.display_status || (row.online ? 'online' : 'offline')
  const device = row.device_id || row.runtime_id || '—'
  const sw = row.worker_software_id || '—'
  return `${row.display_name} · ${device} · ${sw} · ${status}`
}
